export * from "./SimpleProductTeaser";
